import 'slick-carousel';

const $window = $(window);

function initiallizeSlider($slider) {
  if ($window.width() <= 767) {
		if (! $slider.find('.slick-initialized').length) {
      $slider.find('.js-slides').slick({
		    prevArrow: false,
		    nextArrow: false,
		    slidesToShow: 1,
		    slidesToScroll: 1,
		    infinite: true,
		    dots: false,
		    autoplay: false,
		    autoplaySpeed: 2000,
		  });
		}
	} else {
		if ($slider.find('.slick-initialized').length) {
			$slider.find('.js-slides').slick('unslick');
		}
	}
}

const $sliderFeature = $('.js-slider-card');

if ($window.width() <= 767) {
  $sliderFeature.each(function() {
    const $this = $(this);
    const $arrowPrev = $this.find('.js-slider-prev');
    const $arrowNext = $this.find('.js-slider-next');

    if (! $this.find('.slick-initialized').length) {
      $this.find('.js-slides').slick({
        prevArrow: $arrowPrev,
        nextArrow: $arrowNext,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 2000,
      });
    }

    $window.on('resize', function() {
      initiallizeSlider($this)
    });
  })
}
